export const countryListEN = {
  Afghanistan: "AF",
  "Aland Islands": "AX",
  Albania: "AL",
  Algeria: "DZ",
  "American Samoa": "AS",
  Andorra: "AD",
  Angola: "AO",
  Anguilla: "AI",
  Antarctica: "AQ",
  "Antigua and Barbuda": "AG",
  Argentina: "AR",
  Armenia: "AM",
  Aruba: "AW",
  Australia: "AU",
  Austria: "AT",
  Azerbaijan: "AZ",
  Bahamas: "BS",
  Bahrain: "BH",
  Bangladesh: "BD",
  Barbados: "BB",
  Belarus: "BY",
  Belgium: "BE",
  Belize: "BZ",
  Benin: "BJ",
  Bermuda: "BM",
  Bhutan: "BT",
  Bolivia: "BO",
  "Bonaire, Saint Eustatius and Saba": "BQ",
  "Bosnia and Herzegovina": "BA",
  Botswana: "BW",
  "Bouvet Island": "BV",
  Brazil: "BR",
  "British Indian Ocean Territory": "IO",
  "British Virgin Islands": "VG",
  Brunei: "BN",
  Bulgaria: "BG",
  "Burkina Faso": "BF",
  Burundi: "BI",
  Cambodia: "KH",
  Cameroon: "CM",
  Canada: "CA",
  "Cape Verde": "CV",
  "Cayman Islands": "KY",
  "Central African Republic": "CF",
  Chad: "TD",
  Chile: "CL",
  China: "CN",
  "Christmas Island": "CX",
  "Cocos Islands": "CC",
  Colombia: "CO",
  Comoros: "KM",
  "Cook Islands": "CK",
  "Costa Rica": "CR",
  Croatia: "HR",
  Cuba: "CU",
  Curacao: "CW",
  Cyprus: "CY",
  "Czech Republic": "CZ",
  "Democratic Republic of the Congo": "CD",
  Denmark: "DK",
  Djibouti: "DJ",
  Dominica: "DM",
  "Dominican Republic": "DO",
  "East Timor": "TL",
  Ecuador: "EC",
  Egypt: "EG",
  "El Salvador": "SV",
  "Equatorial Guinea": "GQ",
  Eritrea: "ER",
  Estonia: "EE",
  Ethiopia: "ET",
  "Falkland Islands": "FK",
  "Faroe Islands": "FO",
  Fiji: "FJ",
  Finland: "FI",
  France: "FR",
  "French Guiana": "GF",
  "French Polynesia": "PF",
  "French Southern Territories": "TF",
  Gabon: "GA",
  Gambia: "GM",
  Georgia: "GE",
  Germany: "DE",
  Ghana: "GH",
  Gibraltar: "GI",
  Greece: "GR",
  Greenland: "GL",
  Grenada: "GD",
  Guadeloupe: "GP",
  Guam: "GU",
  Guatemala: "GT",
  Guernsey: "GG",
  Guinea: "GN",
  "Guinea-Bissau": "GW",
  Guyana: "GY",
  Haiti: "HT",
  "Heard Island and McDonald Islands": "HM",
  Honduras: "HN",
  "Hong Kong": "HK",
  Hungary: "HU",
  Iceland: "IS",
  India: "IN",
  Indonesia: "ID",
  Iran: "IR",
  Iraq: "IQ",
  Ireland: "IE",
  "Isle of Man": "IM",
  Israel: "IL",
  Italy: "IT",
  "Ivory Coast": "CI",
  Jamaica: "JM",
  Japan: "JP",
  Jersey: "JE",
  Jordan: "JO",
  Kazakhstan: "KZ",
  Kenya: "KE",
  Kiribati: "KI",
  Kosovo: "XK",
  Kuwait: "KW",
  Kyrgyzstan: "KG",
  Laos: "LA",
  Latvia: "LV",
  Lebanon: "LB",
  Lesotho: "LS",
  Liberia: "LR",
  Libya: "LY",
  Liechtenstein: "LI",
  Lithuania: "LT",
  Luxembourg: "LU",
  Macao: "MO",
  Macedonia: "MK",
  Madagascar: "MG",
  Malawi: "MW",
  Malaysia: "MY",
  Maldives: "MV",
  Mali: "ML",
  Malta: "MT",
  "Marshall Islands": "MH",
  Martinique: "MQ",
  Mauritania: "MR",
  Mauritius: "MU",
  Mayotte: "YT",
  Mexico: "MX",
  Micronesia: "FM",
  Moldova: "MD",
  Monaco: "MC",
  Mongolia: "MN",
  Montenegro: "ME",
  Montserrat: "MS",
  Morocco: "MA",
  Mozambique: "MZ",
  Myanmar: "MM",
  Namibia: "NA",
  Nauru: "NR",
  Nepal: "NP",
  Netherlands: "NL",
  "New Caledonia": "NC",
  "New Zealand": "NZ",
  Nicaragua: "NI",
  Niger: "NE",
  Nigeria: "NG",
  Niue: "NU",
  "Norfolk Island": "NF",
  "North Korea": "KP",
  "Northern Mariana Islands": "MP",
  Norway: "NO",
  Oman: "OM",
  Pakistan: "PK",
  Palau: "PW",
  "Palestinian Territory": "PS",
  Panama: "PA",
  "Papua New Guinea": "PG",
  Paraguay: "PY",
  Peru: "PE",
  Philippines: "PH",
  Pitcairn: "PN",
  Poland: "PL",
  Portugal: "PT",
  "Puerto Rico": "PR",
  Qatar: "QA",
  "Republic of the Congo": "CG",
  Reunion: "RE",
  Romania: "RO",
  Russia: "RU",
  Rwanda: "RW",
  "Saint Barthelemy": "BL",
  "Saint Helena": "SH",
  "Saint Kitts and Nevis": "KN",
  "Saint Lucia": "LC",
  "Saint Martin": "MF",
  "Saint Pierre and Miquelon": "PM",
  "Saint Vincent and the Grenadines": "VC",
  Samoa: "WS",
  "San Marino": "SM",
  "Sao Tome and Principe": "ST",
  "Saudi Arabia": "SA",
  Senegal: "SN",
  Serbia: "RS",
  Seychelles: "SC",
  "Sierra Leone": "SL",
  Singapore: "SG",
  "Sint Maarten": "SX",
  Slovakia: "SK",
  Slovenia: "SI",
  "Solomon Islands": "SB",
  Somalia: "SO",
  "South Africa": "ZA",
  "South Georgia and the South Sandwich Islands": "GS",
  "South Korea": "KR",
  "South Sudan": "SS",
  Spain: "ES",
  "Sri Lanka": "LK",
  Sudan: "SD",
  Suriname: "SR",
  "Svalbard and Jan Mayen": "SJ",
  Swaziland: "SZ",
  Sweden: "SE",
  Switzerland: "CH",
  Syria: "SY",
  Taiwan: "TW",
  Tajikistan: "TJ",
  Tanzania: "TZ",
  Thailand: "TH",
  Togo: "TG",
  Tokelau: "TK",
  Tonga: "TO",
  "Trinidad and Tobago": "TT",
  Tunisia: "TN",
  Turkey: "TR",
  Turkmenistan: "TM",
  "Turks and Caicos Islands": "TC",
  Tuvalu: "TV",
  "U.S. Virgin Islands": "VI",
  Uganda: "UG",
  Ukraine: "UA",
  "United Arab Emirates": "AE",
  "United Kingdom": "GB",
  "United States": "US",
  "United States Minor Outlying Islands": "UM",
  Uruguay: "UY",
  Uzbekistan: "UZ",
  Vanuatu: "VU",
  Vatican: "VA",
  Venezuela: "VE",
  Vietnam: "VN",
  "Wallis and Futuna": "WF",
  "Western Sahara": "EH",
  Yemen: "YE",
  Zambia: "ZM",
  Zimbabwe: "ZW",
};

export const countryListFR = {
  Afghanistan: "AF",
  "Aland (Îles)": "AX",
  Albanie: "AL",
  Algérie: "DZ",
  "Samoa américaines": "AS",
  Andorre: "AD",
  Angola: "AO",
  Anguilla: "AI",
  Antarctique: "AQ",
  "Antigua et Barbuda": "AG",
  Argentine: "AR",
  Arménie: "AM",
  Aruba: "AW",
  Australie: "AU",
  Autriche: "AT",
  Azerbaïdjan: "AZ",
  Bahamas: "BS",
  Bahreïn: "BH",
  Bangladesh: "BD",
  Barbade: "BB",
  Bélarus: "BY",
  Belgique: "BE",
  Belize: "BZ",
  Bénin: "BJ",
  Bermudes: "BM",
  Bhoutan: "BT",
  Birmanie: "MM",
  Bolivie: "BO",
  "Bonaire, Saint Eustache et Saba": "BQ",
  "Bosnie and Herzégovine": "BA",
  Botswana: "BW",
  "Île Bouvet": "BV",
  Brésil: "BR",
  "Territoire britannique de l'océan Indien": "IO",
  "Îles Vierges britanniques": "VG",
  Brunei: "BN",
  Bulgarie: "BG",
  "Burkina Faso": "BF",
  Burundi: "BI",
  Cambodge: "KH",
  Cameroun: "CM",
  Canada: "CA",
  "Cap-Vert": "CV",
  "Îles Caïmans": "KY",
  "République centrafricaine": "CF",
  Tchad: "TD",
  Chili: "CL",
  Chine: "CN",
  "Île Christmas": "CX",
  "Îles Cocos": "CC",
  Colombie: "CO",
  Comores: "KM",
  "Îles Cook": "CK",
  "Costa Rica": "CR",
  Croatie: "HR",
  Cuba: "CU",
  Curaçao: "CW",
  Chypre: "CY",
  "République tchèque": "CZ",
  "République démocratique du Congo": "CD",
  Danemark: "DK",
  Djibouti: "DJ",
  Dominique: "DM",
  "République dominicaine": "DO",
  "Timor oriental": "TL",
  Équateur: "EC",
  Égypte: "EG",
  "El Salvador": "SV",
  "Guinée équatoriale": "GQ",
  Érythrée: "ER",
  Estonie: "EE",
  Éthiopie: "ET",
  "Îles Falkland": "FK",
  "Îles Féroé": "FO",
  Fidji: "FJ",
  Finlande: "FI",
  France: "FR",
  "Guyane française": "GF",
  "Polynésie française": "PF",
  "Territoires français du Sud": "TF",
  Gabon: "GA",
  Gambie: "GM",
  Géorgie: "GE",
  Allemagne: "DE",
  Ghana: "GH",
  Gibraltar: "GI",
  Grèce: "GR",
  Groenland: "GL",
  Grenade: "GD",
  Guadeloupe: "GP",
  Guam: "GU",
  Guatemala: "GT",
  Guernesey: "GG",
  Guinée: "GN",
  "Guinée-Bissau": "GW",
  Guyane: "GY",
  Haiti: "HT",
  "Île Heard et îles McDonald": "HM",
  Honduras: "HN",
  "Hong Kong": "HK",
  Hongrie: "HU",
  Islande: "IS",
  Inde: "IN",
  Indonésie: "ID",
  Iran: "IR",
  Iraq: "IQ",
  Irlande: "IE",
  "Île de Man": "IM",
  Israël: "IL",
  Italie: "IT",
  "Côte d'Ivoire": "CI",
  Jamaïque: "JM",
  Japon: "JP",
  Jersey: "JE",
  Jordanie: "JO",
  Kazakhstan: "KZ",
  Kenya: "KE",
  Kiribati: "KI",
  Kosovo: "XK",
  Koweït: "KW",
  Kirghizistan: "KG",
  Laos: "LA",
  Lettonie: "LV",
  Liban: "LB",
  Lesotho: "LS",
  Liberia: "LR",
  Libye: "LY",
  Liechtenstein: "LI",
  Lituanie: "LT",
  Luxembourg: "LU",
  Macao: "MO",
  Macédoine: "MK",
  Madagascar: "MG",
  Malawi: "MW",
  Malaisie: "MY",
  Maldives: "MV",
  Mali: "ML",
  Malte: "MT",
  "Îles Marshall": "MH",
  Martinique: "MQ",
  Mauritanie: "MR",
  Maurice: "MU",
  Mayotte: "YT",
  Mexique: "MX",
  Micronésie: "FM",
  Moldavie: "MD",
  Monaco: "MC",
  Mongolie: "MN",
  Monténégro: "ME",
  Montserrat: "MS",
  Maroc: "MA",
  Mozambique: "MZ",
  Namibie: "NA",
  Nauru: "NR",
  Népal: "NP",
  "Pays-Bas": "NL",
  "Nouvelle-Calédonie": "NC",
  "Nouvelle-Zélande": "NZ",
  Nicaragua: "NI",
  Niger: "NE",
  Nigeria: "NG",
  Niue: "NU",
  "Île Norfolk": "NF",
  "Corée du Nord": "KP",
  "Îles Mariannes du Nord": "MP",
  Norvège: "NO",
  Oman: "OM",
  Pakistan: "PK",
  Palau: "PW",
  "Territoire palestinien": "PS",
  Panama: "PA",
  "Papouasie-Nouvelle-Guinée": "PG",
  Paraguay: "PY",
  Pérou: "PE",
  Philippines: "PH",
  Pitcairn: "PN",
  Pologne: "PL",
  Portugal: "PT",
  "Porto Rico": "PR",
  Qatar: "QA",
  "République du Congo": "CG",
  Réunion: "RE",
  Roumanie: "RO",
  Russie: "RU",
  Rwanda: "RW",
  "Saint-Barthélemy": "BL",
  "Sainte-Hélène": "SH",
  "Saint-Kitts-et-Nevis": "KN",
  "Sainte-Lucie": "LC",
  "Saint Martin": "MF",
  "Saint Pierre et Miquelon": "PM",
  "Saint-Vincent-et-les-Grenadines": "VC",
  Samoa: "WS",
  "Saint-Marin": "SM",
  "Sao Tomé et Principe": "ST",
  "Arabie Saoudite": "SA",
  Sénégal: "SN",
  Serbie: "RS",
  Seychelles: "SC",
  "Sierra Leone": "SL",
  Singapour: "SG",
  "Saint-Martin": "SX",
  Slovaquie: "SK",
  Slovénie: "SI",
  "Îles Salomon": "SB",
  Somalie: "SO",
  "Afrique du Sud": "ZA",
  "Géorgie du Sud et les îles Sandwich du Sud": "GS",
  "Corée du Sud": "KR",
  "Sud-Soudan": "SS",
  Espagne: "ES",
  "Sri Lanka": "LK",
  Soudan: "SD",
  Suriname: "SR",
  "Svalbard et Jan Mayen": "SJ",
  Swaziland: "SZ",
  Suède: "SE",
  Suisse: "CH",
  Syrie: "SY",
  Taiwan: "TW",
  Tadjikistan: "TJ",
  Tanzanie: "TZ",
  Thaïlande: "TH",
  Togo: "TG",
  Tokelau: "TK",
  Tonga: "TO",
  "Trinité-et-Tobago": "TT",
  Tunisie: "TN",
  Turquie: "TR",
  Turkménistan: "TM",
  "Îles Turks et Caicos": "TC",
  Tuvalu: "TV",
  "Îles Vierges américaines": "VI",
  Ouganda: "UG",
  Ukraine: "UA",
  "Émirats arabes unis": "AE",
  "Royaume-Uni": "GB",
  "États-Unis": "US",
  "Îles mineures éloignées des États-Unis": "UM",
  Uruguay: "UY",
  Ouzbékistan: "UZ",
  Vanuatu: "VU",
  Vatican: "VA",
  Venezuela: "VE",
  Vietnam: "VN",
  "Wallis et Futuna": "WF",
  "Sahara occidental": "EH",
  Yémen: "YE",
  Zambie: "ZM",
  Zimbabwe: "ZW",
};

export const countryListDE = {
  Afghanistan: "AF",
  "Aland Islands": "AX",
  Albanien: "AL",
  Algerien: "DZ",
  "American Samoa": "AS",
  Andorra: "AD",
  Angola: "AO",
  Anguilla: "AI",
  Antarktis: "AQ",
  "Antigua and Barbuda": "AG",
  Argentinien: "AR",
  Armenien: "AM",
  Aruba: "AW",
  Australien: "AU",
  Österreich: "AT",
  Aserbaidschan: "AZ",
  Bahamas: "BS",
  Bahrain: "BH",
  Bangladesch: "BD",
  Barbados: "BB",
  Belarus: "BY",
  Belgien: "BE",
  Belize: "BZ",
  Benin: "BJ",
  Bermuda: "BM",
  Bhutan: "BT",
  Bolivien: "BO",
  "Bonaire, Saint Eustatius und Saba": "BQ",
  "Bosnia and Herzegovina": "BA",
  Botsuana: "BW",
  "Bouvet Island": "BV",
  Brasilien: "BR",
  "British Indian Ocean Territory": "IO",
  "British Virgin Islands": "VG",
  Brunei: "BN",
  Bulgarien: "BG",
  "Burkina Faso": "BF",
  Burundi: "BI",
  Kambodscha: "KH",
  Kamerun: "CM",
  Kanada: "CA",
  "Cape Verde": "Lebenslauf",
  Kaimaninseln: "KY",
  "Central African Republic": "CF",
  Tschad: "TD",
  Chile: "CL",
  China: "CN",
  Kanada: "CA",
  "Cape Verde": "CV",
  "Cayman Islands": "KY",
  "Central African Republic": "CF",
  Tschad: "TD",
  Chile: "CL",
  China: "CN",
  "Christmas Island": "CX",
  "Cocos Islands": "CC",
  Kolumbien: "CO",
  Komoren: "KM",
  "Cook Islands": "CK",
  "Costa Rica": "CR",
  Kroatien: "HR",
  Kuba: "CU",
  Curacao: "CW",
  Zypern: "CY",
  "Tschechische Republik": "CZ",
  "Democratic Republic of the Congo": "CD",
  Dänemark: "DK",
  Dschibuti: "DJ",
  Dominica: "DM",
  "Dominican Republic": "DO",
  Osttimor: "TL",
  Ecuador: "EC",
  Ägypten: "EG",
  "El Salvador": "SV",
  "Equatorial Guinea": "GQ",
  Eritrea: "ER",
  Estland: "EE",
  Äthiopien: "ET",
  Falklandinseln: "FK",
  "Färöer-Inseln": "FO",
  Fidschi: "FJ",
  Finnland: "FI",
  Frankreich: "FR",
  "French Guiana": "GF",
  "Französisch-Polynesien": "PF",
  "French Southern Territories": "TF",
  Gabun: "GA",
  Gambia: "GM",
  Georgien: "GE",
  Deutschland: "DE",
  Ghana: "GH",
  Gibraltar: "GI",
  Griechenland: "GR",
  Grönland: "GL",
  Grenada: "GD",
  Guadeloupe: "GP",
  Guam: "GU",
  Guatemala: "GT",
  Guernsey: "GG",
  Guinea: "GN",
  "Guinea-Bissau": "GW",
  Guyana: "GY",
  Großbritannien: "GB",
  Haiti: "HT",
  "Heard Island and McDonald Islands": "HM",
  Honduras: "HN",
  Hongkong: "HK",
  Ungarn: "HU",
  Island: "IS",
  Indien: "IN",
  Indonesien: "ID",
  Iran: "IR",
  Irak: "IQ",
  Irland: "IE",
  "Isle of Man": "IM",
  Israel: "IL",
  Italien: "IT",
  Elfenbeinküste: "CI",
  Jamaika: "JM",
  Japan: "JP",
  Jersey: "JE",
  Jordanien: "JO",
  Kasachstan: "KZ",
  Kenia: "KE",
  Kiribati: "KI",
  Kosovo: "XK",
  Kuwait: "KW",
  Kirgisistan: "KG",
  Laos: "LA",
  Lettland: "LV",
  Libanon: "LB",
  Lesotho: "LS",
  Liberia: "LR",
  Libyen: "LY",
  Liechtenstein: "LI",
  Litauen: "LT",
  Luxemburg: "LU",
  Macau: "MO",
  Mazedonien: "MK",
  Madagaskar: "MG",
  Malawi: "MW",
  Malaysia: "MY",
  Malediven: "MV",
  Mali: "ML",
  Malta: "MT",
  "Marshall Islands": "MH",
  Martinique: "MQ",
  Mauretanien: "MR",
  Mauritius: "MU",
  Mayotte: "YT",
  Mexiko: "MX",
  Mikronesien: "FM",
  Moldawien: "MD",
  Monaco: "MC",
  Mongolei: "MN",
  Montenegro: "ME",
  Montserrat: "MS",
  Marokko: "MA",
  Mosambik: "MZ",
  Myanmar: "MM",
  Namibia: "NA",
  Nauru: "NR",
  Nepal: "NP",
  Niederlande: "NL",
  "New Caledonia": "NC",
  "New Zealand": "NZ",
  Nicaragua: "NI",
  Niger: "NE",
  Nigeria: "NG",
  Niue: "NU",
  Norfolkinsel: "NF",
  "North Korea": "KP",
  "Northern Mariana Islands": "MP",
  Norwegen: "Nein",
  Oman: "OM",
  Pakistan: "PK",
  Palau: "PW",
  "Palestinian Territory": "PS",
  Panama: "PA",
  "Papua-Neuguinea": "PG",
  Paraguay: "PY",
  Peru: "PE",
  Philippinen: "PH",
  Pitcairn: "PN",
  Polen: "PL",
  Portugal: "PT",
  "Puerto Rico": "PR",
  Katar: "QA",
  "Republic of the Congo": "CG",
  Réunion: "RE",
  Rumänien: "RO",
  Russland: "RU",
  Ruanda: "RW",
  "Saint Barthelemy": "BL",
  "Saint Helena": "SH",
  "Saint Kitts and Nevis": "KN",
  "Saint Lucia": "LC",
  "Saint Martin": "MF",
  "Saint Pierre und Miquelon": "PM",
  "Saint Vincent and the Grenadines": "VC",
  Samoa: "WS",
  "San Marino": "SM",
  "Sao Tome and Principe": "ST",
  "Saudi Arabia": "SA",
  Senegal: "SN",
  Serbien: "RS",
  Seychellen: "SC",
  "Sierra Leone": "SL",
  Singapur: "SG",
  "Sint Maarten": "SX",
  Slowakei: "SK",
  Slowenien: "SI",
  "Salomon Islands": "SB",
  Somalia: "SO",
  "South Africa": "ZA",
  "South Georgia and the South Sandwich Islands": "GS",
  Südkorea: "KR",
  Südsudan: "SS",
  Spanien: "ES",
  "Sri Lanka": "LK",
  Sudan: "SD",
  Suriname: "SR",
  "Svalbard and Jan Mayen": "SJ",
  Swasiland: "SZ",
  Schweden: "SE",
  Schweiz: "CH",
  Syrien: "SY",
  Weihnachtsinsel: "CX",
  Zambia: "ZM",
  "Western Sahara": "EH",
  Vietnam: "VN",
  Venezuela: "VE",
  Uzbekistan: "UZ",
  Uruguay: "UY",
  "United States of America": "US",
  Ukraine: "UA",
  Uganda: "UG",
  "Turks and Caicos Islands": "TC",
  Turkey: "TR",
  Tunisia: "TN",
  "Trinidad and Tobago": "TT",
  Tonga: "TO",
  Thailand: "TH",
  Tanzania: "TZ",
  Tajikistan: "TJ",
  Taiwan: "TW",
  Norway: "NO",
};

export const countryListES = {
  Afganistán: "AF",
  "Islas Aland": "AX",
  Albania: "AL",
  Argelia: "DZ",
  "Samoa Americana": "AS",
  Andorra: "AD",
  Angola: "AO",
  Anguila: "AI",
  Antártida: "AQ",
  "Antigua y Barbuda": "AG",
  Argentina: "AR",
  Armenia: "AM",
  Aruba: "AW",
  Australia: "AU",
  Austria: "AT",
  Azerbaiyán: "AZ",
  Bahamas: "BS",
  Bahréin: "BH",
  Bangladesh: "BD",
  Barbados: "BB",
  Bielorrusia: "BY",
  Bélgica: "BE",
  Belice: "BZ",
  Benín: "BJ",
  Bermudas: "BM",
  Bután: "BT",
  Bolivia: "BO",
  "Bonaire, San Eustaquio y Saba": "BQ",
  "Bosnia y Herzegovina": "BA",
  Botsuana: "BW",
  "Isla Bouvet": "BV",
  Brasil: "BR",
  "Territorio Británico del Océano Índico": "IO",
  "Islas Vírgenes Británicas": "VG",
  Brunei: "BN",
  Bulgaria: "BG",
  "Burkina Faso": "BF",
  Burundi: "BI",
  Camboya: "KH",
  Camerún: "CM",
  Canadá: "CA",
  "Cabo Verde": "CV",
  "Islas Caimán": "KY",
  "República Centroafricana": "CF",
  Chad: "TD",
  Chile: "CL",
  China: "CN",
  "Christmas Island": "CX",
  "Islas Cocos": "CC",
  Colombia: "CO",
  Comoras: "KM",
  "Islas Cook": "CK",
  "Costa Rica": "CR",
  Croacia: "HR",
  Cuba: "CU",
  Curaçao: "CW",
  Chipre: "CY",
  "República Checa": "CZ",
  "República Democrática del Congo": "CD",
  Dinamarca: "DK",
  Yibuti: "DJ",
  Dominica: "DM",
  "República Dominicana": "DO",
  "Timor Oriental": "TL",
  Ecuador: "EC",
  Egipto: "EG",
  "El Salvador": "SV",
  "Guinea Ecuatorial": "GQ",
  Eritrea: "ER",
  Estonia: "EE",
  Etiopía: "ET",
  "Islas Malvinas": "FK",
  "Islas Feroe": "FO",
  Fiyi: "FJ",
  Finlandia: "FI",
  Finlandia: "FI",
  Francia: "FR",
  "Guayana Francesa": "GF",
  "Polinesia Francesa": "PF",
  "Territorios Australes Franceses": "TF",
  Gabón: "GA",
  Gambia: "GM",
  Georgia: "GE",
  Alemania: "DE",
  Ghana: "GH",
  Gibraltar: "GI",
  Grecia: "GR",
  Groenlandia: "GL",
  Granada: "GD",
  Guadalupe: "GP",
  Guam: "GU",
  Guatemala: "GT",
  Guernesey: "GG",
  Guinea: "GN",
  "Guinea-Bissau": "GW",
  Guyana: "GY",
  Haití: "HT",
  "Islas Heard y McDonald": "HM",
  Honduras: "HN",
  "Hong Kong": "HK",
  Hungría: "HU",
  Islandia: "IS",
  India: "IN",
  Indonesia: "ID",
  Irán: "IR",
  Iraq: "IQ",
  Irlanda: "IE",
  "Isla de Man": "IM",
  Israel: "IL",
  Italia: "IT",
  "Costa de Marfil": "CI",
  Jamaica: "JM",
  Japón: "JP",
  Jersey: "JE",
  Jordania: "JO",
  Kazajstán: "KZ",
  Kenia: "KE",
  Kiribati: "KI",
  Kosovo: "XK",
  Kuwait: "KW",
  Kirguistán: "KG",
  Laos: "LA",
  Letonia: "LV",
  Líbano: "LB",
  Lesoto: "LS",
  Liberia: "LR",
  Libia: "LY",
  Liechtenstein: "LI",
  Lituania: "LT",
  Luxemburgo: "LU",
  Macao: "MO",
  Macedonia: "MK",
  Madagascar: "MG",
  Malaui: "MW",
  Malasia: "MY",
  Maldivas: "MV",
  Mali: "ML",
  Malta: "MT",
  "Islas Marshall": "MH",
  Martinica: "MQ",
  Mauritania: "MR",
  Mauricio: "MU",
  Mayotte: "YT",
  México: "MX",
  Micronesia: "FM",
  Moldavia: "MD",
  Mónaco: "MC",
  Mongolia: "MN",
  Montenegro: "ME",
  Montserrat: "MS",
  Marruecos: "MA",
  Mozambique: "MZ",
  Myanmar: "MM",
  Namibia: "NA",
  Nauru: "NR",
  Nepal: "NP",
  "Países Bajos": "NL",
  "Nueva Caledonia": "NC",
  "Nueva Zelanda": "NZ",
  Nicaragua: "NI",
  Níger: "NE",
  Nigeria: "NG",
  Niue: "NU",
  "Isla Norfolk": "NF",
  "Corea del Norte": "KP",
  "Islas Marianas del Norte": "MP",
  Noruega: "NO",
  Omán: "OM",
  Pakistán: "PK",
  Palaos: "PW",
  "Territorio Palestino": "PS",
  Panamá: "PA",
  "Papúa Nueva Guinea": "PG",
  Paraguay: "PY",
  Perú: "PE",
  Filipinas: "PH",
  Pitcairn: "PN",
  Polonia: "PL",
  Portugal: "PT",
  "Puerto Rico": "PR",
  Qatar: "QA",
  "República del Congo": "CG",
  Reunión: "RE",
  Rumanía: "RO",
  Rusia: "RU",
  Ruanda: "RW",
  "San Bartolomé": "BL",
  "Santa Helena": "SH",
  "San Cristóbal y Nieves": "KN",
  "Santa Lucía": "LC",
  "San Martín": "MF",
  "San Pedro y Miquelón": "PM",
  "San Vicente y las Granadinas": "VC",
  Samoa: "WS",
  "San Marino": "SM",
  "Santo Tomé y Príncipe": "ST",
  "Arabia Saudí": "SA",
  Senegal: "SN",
  Serbia: "RS",
  Seychelles: "SC",
  "Sierra Leona": "SL",
  Singapur: "SG",
  "Sint Maarten": "SX",
  Eslovaquia: "SK",
  Eslovenia: "SI",
  "Islas Salomón": "SB",
  Somalia: "SO",
  Sudáfrica: "ZA",
  "Georgia del Sur y las Islas Sandwich del Sur": "GS",
  "Corea del Sur": "KR",
  "Sudán del Sur": "SS",
  España: "ES",
  "Sri Lanka": "LK",
  Sudán: "SD",
  Surinam: "SR",
  "Svalbard y Jan Mayen": "SJ",
  Suazilandia: "SZ",
  Suecia: "SE",
  Suiza: "CH",
  Siria: "SY",
  Taiwán: "TW",
  Tayikistán: "TJ",
  Tanzania: "TZ",
  Tailandia: "TH",
  Togo: "TG",
  Tokelau: "TK",
  Tonga: "TO",
  "Trinidad y Tobago": "TT",
  Túnez: "TN",
  Turquía: "TR",
  Turkmenistán: "TM",
  "Islas Turcas y Caicos": "TC",
  Tuvalu: "TV",
  "Islas Vírgenes de EE.UU.": "VI",
  Uganda: "UG",
  Ucrania: "UA",
  "Emiratos Árabes Unidos": "AE",
  "Reino Unido": "GB",
  "Estados Unidos": "US",
  "Islas Periféricas Menores de Estados Unidos": "UM",
  Uruguay: "UY",
  Uzbekistán: "UZ",
  Vanuatu: "VU",
  Vaticano: "VA",
  Venezuela: "VE",
  Vietnam: "VN",
  "Wallis y Futuna": "WF",
  "Sahara Occidental": "EH",
  Yemen: "YE",
  Zambia: "ZM",
  Zimbabue: "ZW",
};

export const countryListIT = {
  Afghanistan: "AF",
  "Isole Aland": "AX",
  Albania: "AL",
  Algeria: "DZ",
  "Samoa Americane": "AS",
  Andorra: "AD",
  Angola: "AO",
  Anguilla: "AI",
  Antartide: "AQ",
  "Antigua e Barbuda": "AG",
  Argentina: "AR",
  Armenia: "AM",
  Aruba: "AW",
  Australia: "AU",
  Austria: "AT",
  Azerbaigian: "AZ",
  Bahamas: "BS",
  Bahrein: "BH",
  Bangladesh: "BD",
  Barbados: "BB",
  Bielorussia: "BY",
  Belgio: "BE",
  Belize: "BZ",
  Benin: "BJ",
  Bermuda: "BM",
  Bhutan: "BT",
  Bolivia: "BO",
  "Bonaire, Saint Eustatius e Saba": "BQ",
  "Bosnia ed Erzegovina": "BA",
  Botswana: "BW",
  "Isola Bouvet": "BV",
  Brasile: "BR",
  "Territorio britannico dell'Oceano Indiano": "IO",
  "Isole Vergini Britanniche": "VG",
  Brunei: "BN",
  Bulgaria: "BG",
  "Burkina Faso": "BF",
  Burundi: "BI",
  Cambogia: "KH",
  Camerun: "CM",
  Canada: "CA",
  "Capo Verde": "CV",
  "Isole Cayman": "KY",
  "Repubblica Centrafricana": "CF",
  Ciad: "TD",
  Cile: "CL",
  Cina: "CN",
  "Isola di Natale": "CX",
  "Isole Cocos": "CC",
  Colombia: "CO",
  Comore: "KM",
  "Isole Cook": "CK",
  "Costa Rica": "CR",
  Croazia: "HR",
  Cuba: "CU",
  Curacao: "CW",
  Cipro: "CY",
  "Repubblica Ceca": "CZ",
  "Repubblica Democratica del Congo": "CD",
  Danimarca: "DK",
  Gibuti: "DJ",
  Dominica: "DM",
  "Repubblica Dominicana": "DO",
  "Timor Est": "TL",
  Ecuador: "EC",
  Egitto: "EG",
  "El Salvador": "SV",
  "Guinea Equatoriale": "GQ",
  Eritrea: "ER",
  Estonia: "EE",
  Etiopia: "ET",
  "Isole Falkland": "FK",
  "Isole Faroe": "FO",
  Figi: "FJ",
  Finlandia: "FI",
  Francia: "FR",
  "Guiana Francese": "GF",
  "Polinesia Francese": "PF",
  "Territori Francesi del Sud": "TF",
  Gabon: "GA",
  Gambia: "GM",
  Georgia: "GE",
  Germania: "DE",
  Ghana: "GH",
  Gibilterra: "GI",
  Grecia: "GR",
  Groenlandia: "GL",
  Grenada: "GD",
  Guadalupa: "GP",
  Guam: "GU",
  Guatemala: "GT",
  Guernsey: "GG",
  Guinea: "GN",
  "Guinea-Bissau": "GW",
  Guyana: "GY",
  Haiti: "HT",
  "Isola Heard e Isole McDonald": "HM",
  Honduras: "HN",
  "Hong Kong": "HK",
  Ungheria: "HU",
  Islanda: "IS",
  India: "IN",
  Indonesia: "ID",
  Iran: "IR",
  Iraq: "IQ",
  Irlanda: "IE",
  "Isola di Man": "IM",
  Israele: "IL",
  Italia: "IT",
  "Costa d'Avorio": "CI",
  Giamaica: "JM",
  Giappone: "JP",
  Jersey: "JE",
  Giordania: "JO",
  Kazakistan: "KZ",
  Kenya: "KE",
  Kiribati: "KI",
  Kosovo: "XK",
  Kuwait: "KW",
  Kirghizistan: "KG",
  Laos: "LA",
  Lettonia: "LV",
  Libano: "LB",
  Lesotho: "LS",
  Liberia: "LR",
  Libia: "LY",
  Liechtenstein: "LI",
  Lituania: "LT",
  Lussemburgo: "LU",
  Macao: "MO",
  Macedonia: "MK",
  Madagascar: "MG",
  Malawi: "MW",
  Malesia: "MY",
  Maldive: "MV",
  Mali: "ML",
  Malta: "MT",
  "Isole Marshall": "MH",
  Martinica: "MQ",
  Mauritania: "MR",
  Mauritius: "MU",
  Mayotte: "YT",
  Messico: "MX",
  Micronesia: "FM",
  Moldavia: "MD",
  Monaco: "MC",
  Mongolia: "MN",
  Montenegro: "ME",
  Montserrat: "MS",
  Marocco: "MA",
  Mozambico: "MZ",
  Myanmar: "MM",
  Namibia: "NA",
  Nauru: "NR",
  Nepal: "NP",
  "Paesi Bassi": "NL",
  "Nuova Caledonia": "NC",
  "Nuova Zelanda": "NZ",
  Nicaragua: "NI",
  Niger: "NE",
  Nigeria: "NG",
  Niue: "NU",
  "Norfolk Island": "NF",
  "Corea del Nord": "KP",
  "Isole Marianne Settentrionali": "MP",
  Norvegia: "NO",
  Oman: "OM",
  Pakistan: "PK",
  Palau: "PW",
  "Territorio palestinese": "PS",
  Panama: "PA",
  "Papua Nuova Guinea": "PG",
  Paraguay: "PY",
  Perù: "PE",
  Filippine: "PH",
  Pitcairn: "PN",
  Polonia: "PL",
  Portogallo: "PT",
  "Porto Rico": "PR",
  Qatar: "QA",
  "Repubblica del Congo": "CG",
  Riunione: "RE",
  Romania: "RO",
  Russia: "RU",
  Ruanda: "RW",
  "Saint Barthelemy": "BL",
  "Sant'Elena": "SH",
  "Saint Kitts e Nevis": "KN",
  "Santa Lucia": "LC",
  "Saint Martin": "MF",
  "Saint-Pierre e Miquelon": "PM",
  "Saint Vincent e Grenadine": "VC",
  Samoa: "WS",
  "San Marino": "SM",
  "Sao Tomè e Principe": "ST",
  "Arabia Saudita": "SA",
  Senegal: "SN",
  Serbia: "RS",
  Seychelles: "SC",
  "Sierra Leone": "SL",
  Singapore: "SG",
  "Sint Maarten": "SX",
  Slovacchia: "SK",
  Slovenia: "SI",
  "Isole Salomone": "SB",
  Somalia: "SO",
  Sudafrica: "ZA",
  "Georgia del Sud e Isole Sandwich del Sud": "GS",
  "Corea del Sud": "KR",
  "Sud Sudan": "SS",
  Spagna: "ES",
  "Sri Lanka": "LK",
  Sudan: "SD",
  Suriname: "SR",
  "Svalbard e Jan Mayen": "SJ",
  Swaziland: "SZ",
  Svezia: "SE",
  Svizzera: "CH",
  Siria: "SY",
  Taiwan: "TW",
  Tagikistan: "TJ",
  Tanzania: "TZ",
  Thailandia: "TH",
  Togo: "TG",
  Tokelau: "TK",
  Tonga: "TO",
  "Trinidad e Tobago": "TT",
  Tunisia: "TN",
  Turchia: "TR",
  Turkmenistan: "TM",
  "Isole Turks e Caicos": "TC",
  Tuvalu: "TV",
  "Isole Vergini Americane": "VI",
  Uganda: "UG",
  Ucraina: "UA",
  "Emirati Arabi Uniti": "AE",
  "Regno Unito": "GB",
  "Stati Uniti": "US",
  "Isole minori periferiche degli Stati Uniti": "UM",
  Uruguay: "UY",
  Uzbekistan: "UZ",
  Vanuatu: "VU",
  Vaticano: "VA",
  Venezuela: "VE",
  Vietnam: "VN",
  "Wallis e Futuna": "WF",
  "Sahara occidentale": "EH",
  Yemen: "YE",
  Zambia: "ZM",
  Zimbabwe: "ZW",
};
